<div class="network-panel" cdkDrag [style.width.px]="panelWidth" [style.height.px]="panelHeight">
  <div class="network-panel__header" cdkDragHandle>
    <span class="network-panel__header__title">Network Activity</span>
    <div class="network-panel__header__actions">
      <button mat-icon-button (click)="clearRequests()" title="Clear">
        <mat-icon>delete_sweep</mat-icon>
      </button>
      <button mat-icon-button (click)="closePanel()" title="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="network-panel__content">
    <div class="network-panel__table-container">
      <table mat-table [dataSource]="requests" class="network-panel__table">
        <ng-container matColumnDef="method">
          <th mat-header-cell *matHeaderCellDef>Method</th>
          <td mat-cell *matCellDef="let req">{{ req.method }}</td>
        </ng-container>
        <ng-container matColumnDef="url">
          <th mat-header-cell *matHeaderCellDef>URL</th>
          <td mat-cell *matCellDef="let req" class="network-panel__url-cell">{{ req.url }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let req">{{ req.responseStatus ?? '-' }}</td>
        </ng-container>
        <ng-container matColumnDef="duration">
          <th mat-header-cell *matHeaderCellDef>Time</th>
          <td mat-cell *matCellDef="let req">
            {{ req.duration !== null ? req.duration + 'ms' : '-' }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="selectRequest(row)"
          [class.network-panel__row--selected]="selectedRequest?.id === row.id"
          [class.network-panel__row--error]="isFailedRequest(row)"
        ></tr>
      </table>
    </div>
    <div class="network-panel__detail" *ngIf="selectedRequest">
      <mat-tab-group>
        <mat-tab label="Request Headers">
          <pre class="network-panel__pre">{{ formatHeaders(selectedRequest.requestHeaders) }}</pre>
        </mat-tab>
        <mat-tab label="Request Body">
          <pre class="network-panel__pre">{{ formatBody(selectedRequest.requestBody) }}</pre>
        </mat-tab>
        <mat-tab label="Response Headers">
          <pre class="network-panel__pre">{{ formatHeaders(selectedRequest.responseHeaders) }}</pre>
        </mat-tab>
        <mat-tab label="Response">
          <pre class="network-panel__pre">{{ formatBody(selectedRequest.responseBody) }}</pre>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  <div
    class="network-panel__resize-handle"
    (mousedown)="startResize($event)"
    (touchstart)="startResize($event)"
    title="Drag to resize"
  ></div>
</div>
